// extracted by mini-css-extract-plugin
export default {"customeBox":"login_customeBox__WHwRt","title":"login_title__fqn6x"};